import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { PaceActionLink, PaceNotificationActionLinks } from './pace-notification-action-links.interface';

/**
 * A card of grouped actions: the dialogs and external links a notification offers.
 *
 * A group's links render as buttons that report the selection, or — where the host supplied a
 * target — as links the browser follows on its own.
 */
@Component({
    selector: 'pace-notification-action-links',
    imports: [NgTemplateOutlet],
    templateUrl: './pace-notification-action-links.component.html',
    styleUrls: ['./pace-notification-action-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaceNotificationActionLinksComponent {
    public readonly actionLinks = input.required<PaceNotificationActionLinks>();

    public readonly actionSelect = output<PaceActionLink>();
}
